import {createBffHooks} from '~/bff'

import type {
    ExportV2Router,
    ExportTableExpense as Expense,
    ExportTableExpenseType as ExpenseType,
    ReportTableExpense as ReportExpense,
    NoResultsContent,
    FilterQueryParams,
    AsyncExportStatus,
    TriggerAsyncExportInput,
    UpdateExpensePayload,
    ReceiptsSource,
    BulkEditOptions,
    CategoryPickerOptions,
    ExportAccountCategory,
    ExportTagGroup,
    ReimbursementEmployee,
    ReimbursementAmount,
    DirectReimbursementType,
    InitiatedBy,
    ReimbursementDetailsResponse,
    RepresentationAccounts,
    RepresentationLines,
    AddAttendeePayload,
} from './index.bff'

export type {
    Expense,
    ExpenseType,
    ReportExpense,
    NoResultsContent,
    FilterQueryParams,
    AsyncExportStatus,
    TriggerAsyncExportInput,
    UpdateExpensePayload,
    ReceiptsSource,
    BulkEditOptions,
    CategoryPickerOptions,
    ExportAccountCategory,
    ExportTagGroup,
    ReimbursementEmployee,
    ReimbursementAmount,
    DirectReimbursementType,
    InitiatedBy,
    ReimbursementDetailsResponse,
    RepresentationAccounts,
    RepresentationLines,
    AddAttendeePayload,
}

export const bffHooks = createBffHooks<ExportV2Router>()

export const bff = bffHooks.exportV2
